/* unplugin-vue-components disabled */import { render } from "./tcg.vue?vue&type=template&id=ce57cb9c&scoped=true"
import script from "./tcg.vue?vue&type=script&lang=js"
export * from "./tcg.vue?vue&type=script&lang=js"

import "./tcg.vue?vue&type=style&index=0&id=ce57cb9c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce57cb9c"]])

export default __exports__